module.exports = __webpack_public_path__ + "assets/folder-account.54ab384a.svg";